import React from 'react';

import { BackportingEnums } from '../../../../../../generated/compat/backportingEnums';
import { TpAdjustedInfo } from '../../../../../../generated/model/tpAdjustedInfo';
import MatrixDataTable from '../../shared/MatrixDataTable';

export interface Props {
  data?: TpAdjustedInfo[];
  ccy?: BackportingEnums.CcyEnum;
}

const TABLE_FIELDS = [
  'tpAdjustedTurnover',
  'tpAdjustedCostOfGoodsSold',
  'tpAdjustedGrossProfitLoss',
  'tpAdjustedOperatingExpenses',
  'tpAdjustedOperatingProfitLossEbit',
];

const TpAdjustedPLI: React.FC<Props> = ({ data, ccy }) => {
  return (
    <MatrixDataTable
      title={'adjustedPli'}
      translationsScope={'companies:companyFinancials'}
      data={data}
      tableFields={TABLE_FIELDS}
      showCurrency={true}
      ccy={ccy}
    />
  );
};

export default TpAdjustedPLI;
